import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import "./EditSubject.module.scss";
import { colourStyles } from "utilities/colored-select-circle.js";

/**
 * Import components
 */
import { Creator, Selector } from "components/UI/Selectables/Selectables";
/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * Import Actions
 */
import updateUserSubject from "actions/usersubject/update";

const mapStateToProps = (state, props) => {
    return {
        subjects: state.user_subject.entities,
        colors: state.color.entities
    };
};

const mapDispatchToProps = {
    updateUserSubject
};

const valueFromId = (opts, id) => opts.find(o => o.value === id);
const valueFromLabel = (opts, label) => opts.find(o => o.label === label);

class EditSubject extends Component {
    constructor() {
        super();

        this.handleColorChange = this.handleColorChange.bind(this);
        this.updateSubject = this.updateSubject.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

        this.state = {
            subject: null,
            name: ""
        };
    }

    componentDidMount() {
        this.setState({
            subject: this.props.subjects.byId[this.props.subjectId],
            name: this.props.subjects.byId[this.props.subjectId].subject
        });
    }

    handleInputChange(event) {
        let subject = this.state.subject;
        subject[event.target.name] = event.target.value;

        if (
            event.target.name == "teacher" &&
            (!subject["teacher_abbreviation"] ||
                subject["teacher_abbreviation"] == "")
        ) {
            let teacherName = event.target.value;
            teacherName = teacherName.trim();
            var split = teacherName.split(" ");
            if (split.length == 1) {
                let firstLetter = split[0][0] ? split[0][0] + "." : "";
                subject["teacher_abbreviation"] = firstLetter;
            } else if (split.length > 1) {
                var abbreviation = "";
                var firstLetter = "";
                var lastLetter = "";

                //Take first letter of first index in array
                firstLetter = split[0][0] ? split[0][0] + "." : "";

                //Check if array is longer than 1 -> Then we have multiple names in the array. Check if the last index is not empty -> Otherwise render '' instead of undefined.
                lastLetter =
                    split.length > 1
                        ? split[split.length - 1]
                            ? split[split.length - 1][0] + "."
                            : ""
                        : "";

                abbreviation = firstLetter + lastLetter;

                subject["teacher_abbreviation"] = abbreviation;
            }
        }

        this.setState({
            subject: subject
        });
    }

    handleColorChange(event) {
        let subject = this.state.subject;
        subject.color_id = event.value;
        this.setState({
            subject: subject
        });
    }

    updateSubject() {
        this.props.updateUserSubject(this.state.subject).then(result => {
            this.props.onClose();
        });
    }

    render() {
        let colorsFormatted = [];

        this.props.colors.allIds.forEach(colorId => {
            let color = this.props.colors.byId[colorId];
            colorsFormatted.push({
                value: color.id,
                label: color.name,
                color: color.color
            });
        });

        return (
            <Fragment>
                <div styleName="input-content">
                    <div styleName="top-bar">
                        <h1 styleName="title">
                            {this.state.name}{" "}
                            {this.state.name.length > 12 && <br />} aanpassen
                        </h1>
                    </div>
                    <div styleName="card-content">
                        <div styleName="subject-wrapper">
                            <p>Vak*</p>
                            <div styleName="subject-selector">
                                <input
                                    styleName="input-teacher"
                                    type="text"
                                    name="subject"
                                    onChange={this.handleInputChange}
                                    value={
                                        this.state.subject &&
                                        this.state.subject.subject
                                    }
                                />
                            </div>
                        </div>
                        {/* <div styleName='new-subject'> */}
                        <div styleName="new-subject-wrapper">
                            <div styleName="abbreviation">
                                <p>Afkorting*</p>
                                <input
                                    styleName="input-abbreviation"
                                    maxLength="3"
                                    type="text"
                                    name="subject_abbreviation"
                                    onChange={this.handleInputChange}
                                    value={
                                        this.state.subject &&
                                        this.state.subject.subject_abbreviation
                                    }
                                    id="subject-abbreviation"
                                />
                            </div>
                            <div styleName="subject-color">
                                <p>Vakkleur*</p>
                                <Select
                                    onChange={this.handleColorChange}
                                    value={valueFromId(
                                        colorsFormatted,
                                        this.state.subject &&
                                            this.state.subject.color_id
                                    )}
                                    isSearchable={false}
                                    options={colorsFormatted}
                                    styles={colourStyles}
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                />
                            </div>
                        </div>
                        {/* </div> */}
                        <div styleName="new-subject-wrapper">
                            <div styleName="teacher">
                                <p>Docent</p>
                                <input
                                    styleName="input-teacher"
                                    placeholder="Docent naam (optioneel)"
                                    name="teacher"
                                    onChange={this.handleInputChange}
                                    value={
                                        this.state.subject &&
                                        this.state.subject.teacher
                                    }
                                    maxLength="35"
                                    id="teacher-abbreviation"
                                    type="text"
                                />
                            </div>
                            <div styleName="teacher-abbreviation">
                                <p>Afkorting</p>
                                <input
                                    styleName="input-teacher"
                                    maxLength="8"
                                    id="teacher-abbreviation"
                                    name="teacher_abbreviation"
                                    onChange={this.handleInputChange}
                                    value={
                                        this.state.subject &&
                                        this.state.subject.teacher_abbreviation
                                    }
                                    type="text"
                                />
                            </div>
                        </div>

                        <div styleName="buttons">
                            <p onClick={this.props.onClose}>Annuleer</p>
                            <p styleName="save" onClick={this.updateSubject}>
                                {"Bijwerken"}
                            </p>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditSubject);
